/* eslint-disable newline-before-return */
import { Grid } from "@mui/material";

import { FormRow } from "@/components/FormEngine/types";

import { BaseRendererProps } from "../../types";
import { FieldRenderer } from "../FieldRenderer";

interface RowRendererProps extends BaseRendererProps {
  row: FormRow;
  fieldsMap?: Record<string, any>;
}

const isHiddenEffective = (
  path: string[],
  baseHidden?: boolean,
  fieldsMap?: Record<string, any>,
) => {
  const k = path.join(".");
  const override = fieldsMap?.[k];
  if (typeof override?.hidden === "boolean") return override.hidden;
  return baseHidden ?? false;
};

export const RowRenderer: React.FC<RowRendererProps> = ({
  row,
  formState,
  onFieldChange,
  fieldsMap,
}) => {
  const visibleFields = row.fields.filter(
    (f) => !isHiddenEffective(f.path, f.hidden, fieldsMap),
  );

  const fieldsCount = visibleFields.length || 1;
  const gridSize = Math.max(3, Math.floor(12 / fieldsCount));

  return (
    <Grid container spacing={2} sx={{ mb: 2 }}>
      {visibleFields.map((field) => (
        <Grid size={{ xs: 12, sm: gridSize }} key={field.id}>
          <FieldRenderer
            field={field}
            formState={formState}
            onFieldChange={onFieldChange}
            effectiveHidden={false} // visible garanti, le filtrage est déjà fait ici
          />
        </Grid>
      ))}
    </Grid>
  );
};
